import React, { useEffect } from 'react'
import { Box, Typography, Grid2 } from '@mui/material'
import { useAuthStore } from 'context/AuthStore'
import { GRAY_COLORS } from 'asterX-UI'
import { Check, NotInterested } from '@mui/icons-material'
import { EyeIcon } from 'asterX-UI/Icons'
import { FilePlusIcon2 } from 'asterX-UI/Icons/FilePlusIcon2'
import { HourglassIcon } from 'asterX-UI/Icons/HourglassIcon'
// import { ClockIcon } from '@mui/x-date-pickers'
import { LayersThree } from 'asterX-UI/Icons/LayersThree'
import { HEAD_UNDERWRITER, SUPER_UNDERWRITER, UNDERWRITER } from 'lib/constants/roles'
import { useHomeStore } from 'context/HomeStore'
// import { formatTime } from 'lib/utils'

const StatisticCard = ({ label, value, icon }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        padding: '24px',
        border: `1px solid ${GRAY_COLORS[200]}`,
        borderRadius: '12px',
        gap: 1
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: '36px', fontWeight: 600, color: GRAY_COLORS[900] }}>{value}</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: `1px solid ${GRAY_COLORS[100]}`,
            backgroundColor: GRAY_COLORS[100],
            borderRadius: '50%',
            width: 40,
            height: 40
          }}
        >
          {icon}
        </Box>
      </Box>

      <Typography sx={{ fontSize: '14px', fontWeight: 500, color: GRAY_COLORS[600], marginTop: 'auto' }}>
        {label}
      </Typography>
    </Box>
  )
}

const Dashboard = () => {
  const { authStore } = useAuthStore()
  const {
    homeStore: { underwriterStatistics, countFiltered },
    homeStoreFunc: { getUnderwriterStatistics }
  } = useHomeStore()

  useEffect(() => {
    if ([UNDERWRITER, HEAD_UNDERWRITER, SUPER_UNDERWRITER].includes(authStore.isUserRole)) {
      getUnderwriterStatistics()
    }
    /*TODO - if ([CREDIT_ADMIN].includes(authStore.isUserRole)) {
      getCredAdminStatistic()
    }*/
  }, [authStore.isUserRole])

  if ([SUPER_UNDERWRITER, HEAD_UNDERWRITER].includes(authStore.isUserRole)) {
    return (
      <Grid2
        container
        spacing={4}
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(4, 1fr)' },
          gridTemplateRows: 'auto',
          gap: 4
        }}
      >
        <Grid2 sx={{ gridRow: 'span 2' }}>
          <StatisticCard label="В очереди на обработку" value={countFiltered || 0} icon={<LayersThree />} />
        </Grid2>
        <Grid2>
          <StatisticCard label="Рассмотрено заявок" value={underwriterStatistics?.done || 0} icon={<EyeIcon />} />
        </Grid2>
        <Grid2>
          <StatisticCard label="Одобрено заявок" value={underwriterStatistics?.approved || 0} icon={<Check />} />
        </Grid2>
        <Grid2>
          <StatisticCard
            label="Отказано заявок"
            value={underwriterStatistics?.declined || 0}
            icon={<NotInterested />}
          />
        </Grid2>

        <Grid2>
          <StatisticCard label="Заявок поступило" value={underwriterStatistics?.total || 0} icon={<FilePlusIcon2 />} />
        </Grid2>
        <Grid2>
          <StatisticCard
            label="Заявок на рассмотрении более часа"
            value={underwriterStatistics?.in_work_hour || 0}
            icon={<HourglassIcon />}
          />
        </Grid2>

        {/* <Grid2>
          <StatisticCard
            label="Среднее время рассмотрения"
            value={formatTime(underwriterStatistics?.time) || 0}
            icon={<ClockIcon />}
          />
        </Grid2> */}
      </Grid2>
    )
  }

  /*TODO - if (authStore.isUserRole === CREDIT_ADMIN) {
    return (
      <Grid2 container display="flex" spacing={4}>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <StatisticCard label="Заявок в очереди " value={countFiltered || 0} icon={<FilePlusIcon2 />} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <StatisticCard label="Рассмотрено заявок" value={credAdminStatistic?.done || 0} icon={<EyeIcon />} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <StatisticCard label="Выданно кредитов" value={credAdminStatistic?.issued_loans || 0} icon={<Check />} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <StatisticCard
            label="Среднее время рассмотрения"
            value={formatTime(credAdminStatistic?.time) || 0}
            icon={<ClockIcon />}
          />
        </Grid2>
      </Grid2>
    )
  }*/

  return (
    <Grid2 container display="flex" spacing={4}>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <StatisticCard label="В очереди на рассмотрение" value={countFiltered || 0} icon={<FilePlusIcon2 />} />
      </Grid2>

      {/*  <Grid2 size={{ xs: 12, md: 6 }}>
        <StatisticCard
          label="Среднее время рассмотрения"
          value={formatTime(underwriterStatistics?.time) || 0}
          icon={<ClockIcon />}
        />
      </Grid2> */}

      <Grid2 size={{ xs: 12, md: 4 }}>
        <StatisticCard label="Рассмотрено заявок" value={underwriterStatistics?.done || 0} icon={<EyeIcon />} />
      </Grid2>

      <Grid2 size={{ xs: 12, md: 4 }}>
        <StatisticCard label="Одобрено заявок" value={underwriterStatistics?.approved || 0} icon={<Check />} />
      </Grid2>

      <Grid2 size={{ xs: 12, md: 4 }}>
        <StatisticCard label="Отказано заявок" value={underwriterStatistics?.declined || 0} icon={<NotInterested />} />
      </Grid2>
    </Grid2>
  )
}

export default Dashboard
